export const SERVER_ROOT = process.env.REACT_APP_QUEUE_SERVER || "";
export const STAGEDOOR_PATH = "stagedoor";
export const STAGEDOOR_ROOT = `${SERVER_ROOT}/${STAGEDOOR_PATH}`;
export const ENVIRONMENT_ICON_URL =
  process.env.REACT_APP_ENVIRONMENT_ICON_URL || null;
export const PACKAGE_VERSION = process.env.REACT_APP_PACKAGE_VERSION || "dev";
